<template>
  <div class="width100">
    <div class="width98 margin-auto backwhite">
      <div class="width98 margin-auto pad-bot20 pad-top20">
        <p class="abstract pad-left10 dimensional">项目详情</p>
        <table class="width100 text-ellipsis margin-top20">
          <tr>
            <td class="tdtit">项目名称</td>
            <td class="tdcont">{{ form.title }}</td>
            <td class="tdtit">项目编号</td>
            <td class="tdcont">{{ form.project_number }}</td>
          </tr>
          <tr>
            <td class="tdtit">行业大类</td>
            <td class="tdcont">{{ form.industry_text }}</td>
            <td class="tdtit">行业小类</td>
            <td class="tdcont">{{ form.industry_small_text }}</td>
          </tr>
          <tr>
            <td class="tdtit">研发阶段</td>
            <td class="tdcont">
              {{ form.progress == 1 ? "研究阶段" : "开发阶段" }}
            </td>
            <td class="tdtit">技术关键词</td>
            <td class="tdcont">{{ form.keyword }}</td>
          </tr>
        </table>
        <div class="pad-top20">
          <p class="abstract pad-left10 dimensional">项目实施</p>
          <table class="width100 text-ellipsis margin-top20">
            <tr>
              <td class="tdtit">负 责 人</td>
              <td class="tdcont">{{ forms.nature }}</td>
              <td class="tdtit">承担部门</td>
              <td class="tdcont">{{ forms.name }}</td>
            </tr>
            <tr>
              <td class="tdtit">协作单位</td>
              <td class="tdcont">{{ forms.numbers }}</td>
              <td class="tdtit">立项时间</td>
              <td class="tdcont">{{ forms.date }}</td>
            </tr>
            <tr>
              <td class="tdtit">批准时间</td>
              <td class="tdcont" style="color: #f96d68">
                <span v-if="approval_time == null">{{ approval }}</span>
                <span v-if="approval_time != null"> {{ approval_time }}</span>

                <el-button
                  size="mini"
                  class="margin-left20"
                  v-if="approval_time == null"
                  :disabled="authority_text != '企业负责人' ? true : false"
                  @click="developmentapproval()"
                  >批准立项</el-button
                >
                <el-button
                  size="mini"
                  class="margin-left20"
                  v-if="approval_time != null"
                  @click="initreport()"
                  >查看立项报告</el-button
                >
              </td>
              <td class="tdtit">结题时间</td>
              <td class="tdcont" style="color: #f96d68">
                <span v-if="finish_time == null">{{ finishte }}</span>
                <span v-if="finish_time != null"> {{ finish_time }}</span>
                <el-button
                  size="mini"
                  class="margin-left20"
                  v-if="finish_time == null"
                  :disabled="
                    authority_text != '企业负责人' || finish_status != 1
                      ? true
                      : false
                  "
                  @click="developmentfinish()"
                  >批准结题</el-button
                >
                <el-button
                  size="mini"
                  class="margin-left20"
                  v-if="finish_time != null"
                  @click="closingreport()"
                  >查看结项报告</el-button
                >
              </td>
            </tr>
          </table>
          <table class="width100 text-ellipsis">
            <tr>
              <td class="tdtit" style="border-top: none">项目备注</td>
              <td class="tdconts" style="border-top: none">{{ forms.desc }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="width98 margin-auto backwhite margin-top20 pad-top20 pad-bot20">
      <el-tabs class="width98 margin-auto" type="border-card">
        <el-tab-pane label="立项依据">
          <el-collapse v-model="projectapproval">
            <el-collapse-item title="国内外现状、水平和发展趋势" name="1">
              <template slot="title" appear>
                <div class="width99 margin-auto flex-betweencen">
                  <span>
                    <div class="rediogree"></div>
                    国内外现状、水平和发展趋势</span
                  >
                  <div style="color: #52c5cb">
                    <img
                      style="filter: drop-shadow(0px 0px #52c5cb)"
                      src="@/assets/barsvg/icon／14bj.png"
                      alt=""
                    />编辑
                  </div>
                </div>
              </template>
              <div>
                <el-input
                  type="textarea"
                  :autosize="autosize"
                  placeholder="请在这里输入文字  "
                  v-model="situation"
                >
                </el-input>
                <div class="lineheight20 f12 pad-top10 textalign-left">
                  <p
                    class="
                      bluecolor
                      filebtnbg
                      width98
                      margin-auto
                      flex-betweencen
                    "
                    v-for="(item, index) in situationfiles"
                    :key="index"
                  >
                    <span @click="seafile(item)" class="cursorpointer"
                      ><img src="@/assets/barsvg/icon／12fj.png" alt="" />
                      {{ item.original_name }}</span
                    >

                    <span @click="situationfilesremove(index)">
                      <span class="removebtn cursorpointer"
                        ><i class="el-icon-close"></i
                      ></span>
                    </span>
                  </p>
                  <el-button size="mini"
                    ><el-upload
                      class="avatar-uploader"
                      :action="Apisrc"
                      name="file"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      :on-error="handleerror"
                      :data="user"
                      :headers="head"
                    >
                      添加附件
                    </el-upload></el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    class="margin-left20"
                    @click="situationblur()"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="本项目对公司的作用与意义" name="2">
              <template slot="title" appear>
                <div class="width99 margin-auto flex-betweencen">
                  <span>
                    <div class="rediogree"></div>
                    本项目对公司的作用与意义</span
                  >
                  <div style="color: #52c5cb">
                    <img
                      style="filter: drop-shadow(0px 0px #52c5cb)"
                      src="@/assets/barsvg/icon／14bj.png"
                      alt=""
                    />编辑
                  </div>
                </div>
              </template>
              <div>
                <el-input
                  type="textarea"
                  :autosize="autosize"
                  placeholder="请在这里输入文字  "
                  v-model="meaning"
                >
                </el-input>
                <div class="lineheight20 f12 pad-top10 textalign-left">
                  <p
                    class="
                      bluecolor
                      filebtnbg
                      width98
                      margin-auto
                      flex-betweencen
                    "
                    v-for="(item, index) in meaningfiles"
                    :key="index"
                  >
                    <span @click="seafile(item)" class="cursorpointer"
                      ><img src="@/assets/barsvg/icon／12fj.png" alt="" />
                      {{ item.original_name }}</span
                    >
                    <span @click="meaningfilesremove(index)">
                      <span class="removebtn cursorpointer"
                        ><i class="el-icon-close"></i
                      ></span>
                    </span>
                  </p>
                  <el-button size="mini">
                    <el-upload
                      class="avatar-uploader"
                      :action="Apisrc"
                      name="file"
                      :show-file-list="false"
                      :on-success="meaninghandleAvatarSuccess"
                      :on-error="meaninghandleerror"
                      :data="meaninguser"
                      :headers="head"
                    >
                      添加附件
                    </el-upload></el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    class="margin-left20"
                    @click="meaningblur()"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="项目预期达到的技术水平" name="3">
              <template slot="title" appear>
                <div class="width99 margin-auto flex-betweencen">
                  <span>
                    <div class="rediogree"></div>
                    项目预期达到的技术水平</span
                  >
                  <div style="color: #52c5cb">
                    <img
                      style="filter: drop-shadow(0px 0px #52c5cb)"
                      src="@/assets/barsvg/icon／14bj.png"
                      alt=""
                    />编辑
                  </div>
                </div>
              </template>
              <div>
                <el-input
                  type="textarea"
                  :autosize="autosize"
                  placeholder="请在这里输入文字  "
                  v-model="level"
                >
                </el-input>
                <div class="lineheight20 f12 pad-top10 textalign-left">
                  <p
                    class="
                      bluecolor
                      filebtnbg
                      width98
                      margin-auto
                      flex-betweencen
                    "
                    v-for="(item, index) in levelfiles"
                    :key="index"
                  >
                    <span @click="seafile(item)" class="cursorpointer"
                      ><img src="@/assets/barsvg/icon／12fj.png" alt="" />
                      {{ item.original_name }}</span
                    >
                    <span @click="levelfilesremove(index)">
                      <span class="removebtn cursorpointer"
                        ><i class="el-icon-close"></i
                      ></span>
                    </span>
                  </p>
                  <el-button size="mini">
                    <el-upload
                      class="avatar-uploader"
                      :action="Apisrc"
                      name="file"
                      :show-file-list="false"
                      :on-success="levelhandleAvatarSuccess"
                      :on-error="levelhandleerror"
                      :data="leveluser"
                      :headers="head"
                    >
                      添加附件
                    </el-upload></el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    class="margin-left20"
                    @click="levelblur()"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="项目预期市场前景" name="4">
              <template slot="title" appear>
                <div class="width99 margin-auto flex-betweencen">
                  <span>
                    <div class="rediogree"></div>
                    项目预期市场前景</span
                  >
                  <div style="color: #52c5cb">
                    <img
                      style="filter: drop-shadow(0px 0px #52c5cb)"
                      src="@/assets/barsvg/icon／14bj.png"
                      alt=""
                    />编辑
                  </div>
                </div>
              </template>
              <div>
                <el-input
                  type="textarea"
                  :autosize="autosize"
                  placeholder="请在这里输入文字  "
                  v-model="prospect"
                >
                </el-input>
                <div class="lineheight20 f12 pad-top10 textalign-left">
                  <p
                    class="
                      bluecolor
                      filebtnbg
                      width98
                      margin-auto
                      flex-betweencen
                    "
                    v-for="(item, index) in prospectfiles"
                    :key="index"
                  >
                    <span @click="seafile(item)" class="cursorpointer"
                      ><img src="@/assets/barsvg/icon／12fj.png" alt="" />
                      {{ item.original_name }}</span
                    >
                    <span @click="prospectfilesremove(index)">
                      <span class="removebtn cursorpointer"
                        ><i class="el-icon-close"></i
                      ></span>
                    </span>
                  </p>
                  <el-button size="mini">
                    <el-upload
                      class="avatar-uploader"
                      :action="Apisrc"
                      name="file"
                      :show-file-list="false"
                      :on-success="prospecthandleAvatarSuccess"
                      :on-error="prospecthandleerror"
                      :data="prospectuser"
                      :headers="head"
                    >
                      添加附件
                    </el-upload></el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    class="margin-left20"
                    @click="prospectblur()"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>
        <el-tab-pane label="内容和目标">
          <el-collapse v-model="Contentobjectives">
            <el-collapse-item title="项目主要内容" name="1">
              <template slot="title" appear>
                <div class="width99 margin-auto flex-betweencen">
                  <span>
                    <div class="rediogree"></div>
                    项目主要内容</span
                  >
                  <div style="color: #52c5cb">
                    <img
                      style="filter: drop-shadow(0px 0px #52c5cb)"
                      src="@/assets/barsvg/icon／14bj.png"
                      alt=""
                    />编辑
                  </div>
                </div>
              </template>
              <div>
                <el-input
                  type="textarea"
                  :autosize="autosize"
                  placeholder="请在这里输入文字  "
                  v-model="maincontent"
                >
                </el-input>
                <div class="lineheight20 f12 pad-top10 textalign-left">
                  <p
                    class="
                      bluecolor
                      filebtnbg
                      width98
                      margin-auto
                      flex-betweencen
                    "
                    v-for="(item, index) in maincontentfiles"
                    :key="index"
                  >
                    <span @click="seafile(item)" class="cursorpointer"
                      ><img src="@/assets/barsvg/icon／12fj.png" alt="" />
                      {{ item.original_name }}</span
                    >
                    <span @click="maincontentfilesremove(index)">
                      <span class="removebtn cursorpointer"
                        ><i class="el-icon-close"></i
                      ></span>
                    </span>
                  </p>
                  <el-button size="mini">
                    <el-upload
                      class="avatar-uploader"
                      :action="Apisrc"
                      name="file"
                      :show-file-list="false"
                      :on-success="maincontenthandleAvatarSuccess"
                      :on-error="maincontenthandleerror"
                      :data="maincontentuser"
                      :headers="head"
                    >
                      添加附件
                    </el-upload></el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    class="margin-left20"
                    @click="maincontentblur()"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="项目关键技术" name="2">
              <template slot="title" appear>
                <div class="width99 margin-auto flex-betweencen">
                  <span>
                    <div class="rediogree"></div>
                    项目关键技术</span
                  >
                  <div style="color: #52c5cb">
                    <img
                      style="filter: drop-shadow(0px 0px #52c5cb)"
                      src="@/assets/barsvg/icon／14bj.png"
                      alt=""
                    />编辑
                  </div>
                </div>
              </template>
              <div>
                <el-input
                  type="textarea"
                  :autosize="autosize"
                  placeholder="请在这里输入文字  "
                  v-model="technology"
                >
                </el-input>
                <div class="lineheight20 f12 pad-top10 textalign-left">
                  <p
                    class="
                      bluecolor
                      filebtnbg
                      width98
                      margin-auto
                      flex-betweencen
                    "
                    v-for="(item, index) in technologyfiles"
                    :key="index"
                  >
                    <span @click="seafile(item)" class="cursorpointer"
                      ><img src="@/assets/barsvg/icon／12fj.png" alt="" />
                      {{ item.original_name }}</span
                    >
                    <span @click="technologyfilesremove(index)">
                      <span class="removebtn cursorpointer"
                        ><i class="el-icon-close"></i
                      ></span>
                    </span>
                  </p>
                  <el-button size="mini">
                    <el-upload
                      class="avatar-uploader"
                      :action="Apisrc"
                      name="file"
                      :show-file-list="false"
                      :on-success="technologyhandleAvatarSuccess"
                      :on-error="technologyhandleerror"
                      :data="technologyuser"
                      :headers="head"
                    >
                      添加附件
                    </el-upload></el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    class="margin-left20"
                    @click="technologyblur()"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="技术创新点" name="3">
              <template slot="title" appear>
                <div class="width99 margin-auto flex-betweencen">
                  <span>
                    <div class="rediogree"></div>
                    技术创新点</span
                  >
                  <div style="color: #52c5cb">
                    <img
                      style="filter: drop-shadow(0px 0px #52c5cb)"
                      src="@/assets/barsvg/icon／14bj.png"
                      alt=""
                    />编辑
                  </div>
                </div>
              </template>
              <div>
                <el-input
                  type="textarea"
                  :autosize="autosize"
                  placeholder="请在这里输入文字  "
                  v-model="Innovapoint"
                >
                </el-input>
                <div class="lineheight20 f12 pad-top10 textalign-left">
                  <p
                    class="
                      bluecolor
                      filebtnbg
                      width98
                      margin-auto
                      flex-betweencen
                    "
                    v-for="(item, index) in Innovapointfiles"
                    :key="index"
                  >
                    <span @click="seafile(item)" class="cursorpointer"
                      ><img src="@/assets/barsvg/icon／12fj.png" alt="" />
                      {{ item.original_name }}</span
                    >
                    <span @click="Innovapointfilesremove(index)">
                      <span class="removebtn cursorpointer"
                        ><i class="el-icon-close"></i
                      ></span>
                    </span>
                  </p>
                  <el-button size="mini">
                    <el-upload
                      class="avatar-uploader"
                      :action="Apisrc"
                      name="file"
                      :show-file-list="false"
                      :on-success="InnovapointhandleAvatarSuccess"
                      :on-error="Innovapointhandleerror"
                      :data="Innovapointuser"
                      :headers="head"
                    >
                      添加附件
                    </el-upload></el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    class="margin-left20"
                    @click="Innovapointblur()"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="技术指标和经济指标" name="4">
              <template slot="title" appear>
                <div class="width99 margin-auto flex-betweencen">
                  <span>
                    <div class="rediogree"></div>
                    技术指标和经济指标</span
                  >
                  <div style="color: #52c5cb">
                    <img
                      style="filter: drop-shadow(0px 0px #52c5cb)"
                      src="@/assets/barsvg/icon／14bj.png"
                      alt=""
                    />编辑
                  </div>
                </div>
              </template>
              <div>
                <el-input
                  type="textarea"
                  :autosize="autosize"
                  placeholder="请在这里输入文字  "
                  v-model="Economic"
                >
                </el-input>
                <div class="lineheight20 f12 pad-top10 textalign-left">
                  <p
                    class="
                      bluecolor
                      filebtnbg
                      width98
                      margin-auto
                      flex-betweencen
                    "
                    v-for="(item, index) in Economicfiles"
                    :key="index"
                  >
                    <span @click="seafile(item)" class="cursorpointer"
                      ><img src="@/assets/barsvg/icon／12fj.png" alt="" />
                      {{ item.original_name }}</span
                    >
                    <span @click="Economicfilesremove(index)">
                      <span class="removebtn cursorpointer"
                        ><i class="el-icon-close"></i
                      ></span>
                    </span>
                  </p>
                  <el-button size="mini">
                    <el-upload
                      class="avatar-uploader"
                      :action="Apisrc"
                      name="file"
                      :show-file-list="false"
                      :on-success="EconomichandleAvatarSuccess"
                      :on-error="Economichandleerror"
                      :data="Economicuser"
                      :headers="head"
                    >
                      添加附件
                    </el-upload></el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    class="margin-left20"
                    @click="Economicblur()"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>
        <el-tab-pane label="方法与技术路线">
          <el-collapse v-model="Methodtechnicalroute">
            <el-collapse-item title="方法与技术路线" name="1">
              <template slot="title" appear>
                <div class="width99 margin-auto flex-betweencen">
                  <span>
                    <div class="rediogree"></div>
                    方法与技术路线</span
                  >
                  <div style="color: #52c5cb">
                    <img
                      style="filter: drop-shadow(0px 0px #52c5cb)"
                      src="@/assets/barsvg/icon／14bj.png"
                      alt=""
                    />编辑
                  </div>
                </div>
              </template>
              <div>
                <el-input
                  type="textarea"
                  :autosize="autosize"
                  placeholder="请在这里输入文字  "
                  v-model="circuit"
                >
                </el-input>
                <div class="lineheight20 f12 pad-top10 textalign-left">
                  <p
                    class="
                      bluecolor
                      filebtnbg
                      width98
                      margin-auto
                      flex-betweencen
                    "
                    v-for="(item, index) in circuitfiles"
                    :key="index"
                  >
                    <span @click="seafile(item)" class="cursorpointer"
                      ><img src="@/assets/barsvg/icon／12fj.png" alt="" />
                      {{ item.original_name }}</span
                    >
                    <span @click="circuitfilesremove(index)">
                      <span class="removebtn cursorpointer"
                        ><i class="el-icon-close"></i
                      ></span>
                    </span>
                  </p>
                  <el-button size="mini">
                    <el-upload
                      class="avatar-uploader"
                      :action="Apisrc"
                      name="file"
                      :show-file-list="false"
                      :on-success="circuithandleAvatarSuccess"
                      :on-error="circuithandleerror"
                      :data="circuituser"
                      :headers="head"
                    >
                      添加附件
                    </el-upload></el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    class="margin-left20"
                    @click="circuitblur()"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>
        <el-tab-pane label="现有基础"
          ><el-collapse v-model="Existingfoundation">
            <el-collapse-item title="现有基础" name="1">
              <template slot="title" appear>
                <div class="width99 margin-auto flex-betweencen">
                  <span>
                    <div class="rediogree"></div>
                    现有基础</span
                  >
                  <div style="color: #52c5cb">
                    <img
                      style="filter: drop-shadow(0px 0px #52c5cb)"
                      src="@/assets/barsvg/icon／14bj.png"
                      alt=""
                    />编辑
                  </div>
                </div>
              </template>
              <div>
                <el-input
                  type="textarea"
                  :autosize="autosize"
                  placeholder="请在这里输入文字  "
                  v-model="foundation"
                >
                </el-input>
                <div class="lineheight20 f12 pad-top10 textalign-left">
                  <p
                    class="
                      bluecolor
                      filebtnbg
                      width98
                      margin-auto
                      flex-betweencen
                    "
                    v-for="(item, index) in foundationfiles"
                    :key="index"
                  >
                    <span @click="seafile(item)" class="cursorpointer"
                      ><img src="@/assets/barsvg/icon／12fj.png" alt="" />
                      {{ item.original_name }}</span
                    >
                    <span @click="foundationfilesremove(index)">
                      <span class="removebtn cursorpointer"
                        ><i class="el-icon-close"></i
                      ></span>
                    </span>
                  </p>
                  <el-button size="mini">
                    <el-upload
                      class="avatar-uploader"
                      :action="Apisrc"
                      name="file"
                      :show-file-list="false"
                      :on-success="foundationhandleAvatarSuccess"
                      :on-error="foundationhandleerror"
                      :data="foundationuser"
                      :headers="head"
                    >
                      添加附件
                    </el-upload></el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    class="margin-left20"
                    @click="foundationblur()"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-collapse-item>
          </el-collapse></el-tab-pane
        >
        <el-tab-pane label="项目组成员">
          <Sciencepersonnel></Sciencepersonnel>
        </el-tab-pane>
        <el-tab-pane label="计划与进度">
          <Scienceschedule></Scienceschedule>
        </el-tab-pane>
        <el-tab-pane label="预算与使用">
          <ScienceBudgetusage></ScienceBudgetusage>
        </el-tab-pane>
        <el-tab-pane label="项目结题">
          <el-collapse v-model="projectsummary">
            <el-collapse-item title="项目总结" name="1">
              <template slot="title" appear>
                <div class="width99 margin-auto flex-betweencen">
                  <span>
                    <div class="rediogree"></div>
                    项目总结</span
                  >
                  <div style="color: #52c5cb">
                    <img
                      style="filter: drop-shadow(0px 0px #52c5cb)"
                      src="@/assets/barsvg/icon／14bj.png"
                      alt=""
                    />编辑
                  </div>
                </div>
              </template>
              <div>
                <el-input
                  type="textarea"
                  :autosize="autosize"
                  placeholder="请在这里输入文字  "
                  v-model="Junction"
                >
                </el-input>
                <div class="lineheight20 f12 pad-top10 textalign-left">
                  <p
                    class="
                      bluecolor
                      filebtnbg
                      width98
                      margin-auto
                      flex-betweencen
                    "
                    v-for="(item, index) in Junctionfiles"
                    :key="index"
                  >
                    <span @click="seafile(item)" class="cursorpointer"
                      ><img src="@/assets/barsvg/icon／12fj.png" alt="" />
                      {{ item.original_name }}</span
                    >
                    <span @click="Junctionfilesremove(index)">
                      <span class="removebtn cursorpointer"
                        ><i class="el-icon-close"></i
                      ></span>
                    </span>
                  </p>
                  <el-button size="mini">
                    <el-upload
                      class="avatar-uploader"
                      :action="Apisrc"
                      name="file"
                      :show-file-list="false"
                      :on-success="JunctionhandleAvatarSuccess"
                      :on-error="Junctionhandleerror"
                      :data="Junctionuser"
                      :headers="head"
                    >
                      添加附件
                    </el-upload></el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    class="margin-left20"
                    @click="Junctionblur()"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="结题验收意见" name="2">
              <div class="acceptancecomments" v-if="finish_status == 1">
                本项目已按照项目计划的实施周期和目标顺利完成，且经过测试部门的验收，文档齐全，满足结题验收条件，
                请求予以正常验收。
              </div>
              <div class="width100">
                <div
                  class="
                    width70
                    flex
                    textalign-left
                    borderf1
                    pad-left10
                    lineheight35
                  "
                >
                  <div class="width30 borderright1">项目小组成员</div>
                  <div class="width70 pad-right10">
                    <span
                      class="pad-left10"
                      v-for="(item, index) in rduser"
                      :key="index"
                      >{{ item.realname }}</span
                    >
                  </div>
                </div>
                <div
                  class="
                    width70
                    flex
                    textalign-left
                    borderf1
                    pad-left10
                    lineheight35
                  "
                >
                  <div class="width30 borderright1">项目组长意见</div>
                  <div class="width70 pad-left10">
                    <span v-if="finish_status == 1 || finish_status == 2"
                      >同意结题</span
                    >

                    <el-button
                      @click="applyfinish()"
                      v-if="finish_status == 0"
                      size="small"
                      plain
                      class="margin-left10"
                      >项目完结,申请结题</el-button
                    >
                  </div>
                </div>
                <div
                  class="
                    width70
                    flex
                    textalign-left
                    borderf1
                    pad-left10
                    lineheight35
                  "
                >
                  <div class="width30 borderright1">企业负责人意见</div>
                  <div class="width70 pad-left10">
                    <span v-if="finish_status == 2">同意结题</span>
                    <span v-if="finish_status == 1">待审批</span>
                    <el-button
                      @click="developmentfinish()"
                      v-if="finish_status == 1"
                      size="small"
                      plain
                      class="margin-left10"
                      >批准结题</el-button
                    >
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 错误信息 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <!-- 立项报告 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleinitreport"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="50%"
      class="errorboxs"
    >
      <initiationreport></initiationreport>
    </el-dialog>
    <!-- 结项报告 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleclosreport"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="53%"
      class="errorboxs"
    >
      <Closingreport></Closingreport>
    </el-dialog>
  </div>
</template>
<script>
import Sciencepersonnel from "./Science-personnel.vue";
import Scienceschedule from "./Science-schedule.vue";
import ScienceBudgetusage from "./Science-Budgetusage.vue";
import initiationreport from "./initiation_report.vue";
import Closingreport from "./Closing_report.vue";
import {
  Projectdetail,
  enttechresearchdevelopmentremovefile,
  enttechresearchdevelopmentmodifyvalue,
} from "@/api/Center/Center.api";
import { Base64 } from "js-base64";
import {
  enttechresearchdevelopmentapproval,
  enttechresearchdevelopmentfinish,
  enttechresearchdevelopmentapplyfinish,
} from "@/api/loader/loder.api";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisibleinitreport: false,
      dialogVisibleclosreport: false,
      authority_text: "",
      approval: "",
      finishte: "",
      centerNums: "",
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      // 国内外现状、水平和发展趋势
      situation: "",
      situationfocuslen: "",
      situationfiles: [],
      situationid: [],
      user: {
        project_id: "",
        value_id: "",
      },
      // 本项目对公司的作用与意义
      meaningfocuslen: "",
      meaning: "",
      meaningfiles: [],
      meaningid: [],
      meaninguser: {
        project_id: "",
        value_id: "",
      },
      // 项目预期达到的技术水平
      levelfocuslen: "",
      level: "",
      levelfiles: [],
      levelid: [],
      leveluser: {
        project_id: "",
        value_id: "",
      },
      // 项目预期市场前景
      prospectfocuslen: "",
      prospect: "",
      prospectfiles: [],
      prospectid: [],
      prospectuser: {
        project_id: "",
        value_id: "",
      },
      //  项目主要内容
      maincontentfocuslen: "",
      maincontent: "",
      maincontentfiles: [],
      maincontentid: [],
      maincontentuser: {
        project_id: "",
        value_id: "",
      },
      //  项目关键技术
      technologyfocuslen: "",
      technology: "",
      technologyfiles: [],
      technologyid: [],
      technologyuser: {
        project_id: "",
        value_id: "",
      },
      // 技术创新点
      Innovapointfocuslen: "",
      Innovapoint: "",
      Innovapointfiles: [],
      Innovapointid: [],
      Innovapointuser: {
        project_id: "",
        value_id: "",
      },
      // 技术指标和经济指标
      Economicfocuslen: "",
      Economic: "",
      Economicfiles: [],
      Economicid: [],
      Economicuser: {
        project_id: "",
        value_id: "",
      },
      // 方法和技术线路
      circuitfocuslen: "",
      circuit: "",
      circuitfiles: [],
      circuitid: [],
      circuituser: {
        project_id: "",
        value_id: "",
      },
      // 现有基础
      foundationfocuslen: "",
      foundation: "",
      foundationfiles: [],
      foundationid: [],
      foundationuser: {
        project_id: "",
        value_id: "",
      },
      // 结题
      Junctionfocuslen: "",
      Junction: "",
      Junctionfiles: [],
      Junctionid: [],
      Junctionuser: {
        project_id: "",
        value_id: "",
      },
      Apisrc: "",
      head: {
        token: window.sessionStorage.getItem("token"),
      },
      textarea: "",
      summary: "",
      projectapproval: ["1"],
      Contentobjectives: ["1"],
      Methodtechnicalroute: ["1"],
      Existingfoundation: ["1"],
      projectsummary: ["1"],

      form: {
        title: "",
        progress: "",
        project_number: "",
        industry_small_text: "",
        industry_text: "",
        keyword: "",
      },

      approval_time: "",
      finish_status: "",
      finish_time: "",
      rduser: [],
      forms: {
        name: "",
        numbers: "",
        date: "",
        nature: "",
        desc: "",
      },
    };
  },
  components: {
    // 项目组成员
    Sciencepersonnel,
    // 计划与进度
    Scienceschedule,
    // 预算与使用
    ScienceBudgetusage,
    // 立项报告
    initiationreport,
    // 结项报告
    Closingreport,
  },
  methods: {
    seafile(item) {
      var url = window.g.Apisrc + item.url;
      window.open(
        window.g.previewurl + "?url=" + encodeURIComponent(Base64.encode(url))
      );
    },
    // 批准立项
    developmentapproval() {
      enttechresearchdevelopmentapproval({ project_id: this.centerNums }).then(
        (res) => {
          if (res.data.code == 200) {
            this.refresh();
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },
    // 立项报告
    initreport() {
      this.dialogVisibleinitreport = true;
    },
    // 批准结题
    developmentfinish() {
      enttechresearchdevelopmentfinish({ project_id: this.centerNums }).then(
        (res) => {
          if (res.data.code == 200) {
            this.refresh();
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },
    // 结项报告
    closingreport() {
      this.dialogVisibleclosreport = true;
    },
    // 申请结项
    applyfinish() {
      enttechresearchdevelopmentapplyfinish({
        project_id: this.centerNums,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    //  国内外现状、水平和发展趋势
    // 文本框
    situationblur() {
      enttechresearchdevelopmentmodifyvalue({
        id: this.situationid,
        value: this.situation,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 上传附件
    handleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        this.refresh();
      }
    },
    handleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    // 附件删除
    situationfilesremove(index) {
      enttechresearchdevelopmentremovefile({
        file_id: this.situationfiles[index].id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 本项目对公司的作用与意义
    // 文本框

    meaningblur() {
      enttechresearchdevelopmentmodifyvalue({
        id: this.meaningid,
        value: this.meaning,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 上传附件
    meaninghandleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        this.refresh();
      }
    },
    meaninghandleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    // 附件删除
    meaningfilesremove(index) {
      enttechresearchdevelopmentremovefile({
        file_id: this.meaningfiles[index].id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 项目预期达到的技术水平level
    // 文本框

    levelblur() {
      enttechresearchdevelopmentmodifyvalue({
        id: this.levelid,
        value: this.level,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 上传附件
    levelhandleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        this.refresh();
      }
    },
    levelhandleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    // 附件删除
    levelfilesremove(index) {
      enttechresearchdevelopmentremovefile({
        file_id: this.levelfiles[index].id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 项目预期市场前景prospect
    // 文本框

    prospectblur() {
      enttechresearchdevelopmentmodifyvalue({
        id: this.prospectid,
        value: this.prospect,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 上传附件
    prospecthandleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        this.refresh();
      }
    },
    prospecthandleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    // 附件删除
    prospectfilesremove(index) {
      enttechresearchdevelopmentremovefile({
        file_id: this.prospectfiles[index].id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 项目主要内容maincontent
    // 文本框

    maincontentblur() {
      enttechresearchdevelopmentmodifyvalue({
        id: this.maincontentid,
        value: this.maincontent,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 上传附件
    maincontenthandleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        this.refresh();
      }
    },
    maincontenthandleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    // 附件删除
    maincontentfilesremove(index) {
      enttechresearchdevelopmentremovefile({
        file_id: this.maincontentfiles[index].id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 项目关键技术technology
    // 文本框

    technologyblur() {
      enttechresearchdevelopmentmodifyvalue({
        id: this.technologyid,
        value: this.technology,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 上传附件
    technologyhandleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        this.refresh();
      }
    },
    technologyhandleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    // 附件删除
    technologyfilesremove(index) {
      enttechresearchdevelopmentremovefile({
        file_id: this.technologyfiles[index].id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 技术创新点Innovapoint
    // 文本框

    Innovapointblur(e) {
      enttechresearchdevelopmentmodifyvalue({
        id: this.Innovapointid,
        value: this.Innovapoint,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 上传附件
    InnovapointhandleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        this.refresh();
      }
    },
    Innovapointhandleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    // 附件删除
    Innovapointfilesremove(index) {
      enttechresearchdevelopmentremovefile({
        file_id: this.Innovapointfiles[index].id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 技术指标和经济指标Economic
    // 文本框

    Economicblur() {
      enttechresearchdevelopmentmodifyvalue({
        id: this.Economicid,
        value: this.Economic,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 上传附件
    EconomichandleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        this.refresh();
      }
    },
    Economichandleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    // 附件删除
    Economicfilesremove(index) {
      enttechresearchdevelopmentremovefile({
        file_id: this.Economicfiles[index].id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 方法和技术线路circuit
    // 文本框

    circuitblur() {
      enttechresearchdevelopmentmodifyvalue({
        id: this.circuitid,
        value: this.circuit,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 上传附件
    circuithandleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        this.refresh();
      }
    },
    circuithandleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    // 附件删除
    circuitfilesremove(index) {
      enttechresearchdevelopmentremovefile({
        file_id: this.circuitfiles[index].id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 现有基础foundation
    // 文本框

    foundationblur() {
      enttechresearchdevelopmentmodifyvalue({
        id: this.foundationid,
        value: this.foundation,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 上传附件
    foundationhandleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        this.refresh();
      }
    },
    foundationhandleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    // 附件删除
    foundationfilesremove(index) {
      enttechresearchdevelopmentremovefile({
        file_id: this.foundationfiles[index].id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 项目结题Junction
    // 文本框

    Junctionblur() {
      enttechresearchdevelopmentmodifyvalue({
        id: this.Junctionid,
        value: this.Junction,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 上传附件
    JunctionhandleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        this.refresh();
      }
    },
    Junctionhandleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    // 附件删除
    Junctionfilesremove(index) {
      enttechresearchdevelopmentremovefile({
        file_id: this.Junctionfiles[index].id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 刷新
    refresh() {
      this.$loading.show(); // 显示loading
      Projectdetail({ id: this.centerNums }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.form.title = res.data.data.title;
          this.finish_status = res.data.data.finish_status;
          this.form.project_number = res.data.data.project_number;
          this.form.keyword = res.data.data.keyword;
          this.form.industry_small_text = res.data.data.industry_small_text;
          this.form.industry_text = res.data.data.industry_text;
          this.form.progress = res.data.data.progress;
          this.forms.date = res.data.data.start_date;
          this.forms.name = res.data.data.research_dev_title;
          this.forms.numbers = res.data.data.cooperation;
          this.forms.nature = res.data.data.manager_name;
          this.forms.desc = res.data.data.remark;
          this.approval = res.data.data.approval_text;
          this.approval_time = res.data.data.approval_time;
          this.finish_time = res.data.data.finish_time;
          this.finishte = res.data.data.finish_text;
          this.rduser = res.data.data.rduser;
          // 国内外现状、水平和发展趋势
          this.situation = res.data.data.value[0].value;
          this.situationfiles = res.data.data.value[0].files;
          this.situationid = res.data.data.value[0].id;
          this.user.project_id = res.data.data.value[0].project_id;
          this.user.value_id = res.data.data.value[0].id;
          // 本项目对公司的作用与意义
          this.meaning = res.data.data.value[1].value;
          this.meaningfiles = res.data.data.value[1].files;
          this.meaningid = res.data.data.value[1].id;
          this.meaninguser.project_id = res.data.data.value[1].project_id;
          this.meaninguser.value_id = res.data.data.value[1].id;
          // 项目预期达到的技术水平
          this.level = res.data.data.value[2].value;
          this.levelfiles = res.data.data.value[2].files;
          this.levelid = res.data.data.value[2].id;
          this.leveluser.project_id = res.data.data.value[2].project_id;
          this.leveluser.value_id = res.data.data.value[2].id;
          // 项目预期市场前景
          this.prospect = res.data.data.value[3].value;
          this.prospectfiles = res.data.data.value[3].files;
          this.prospectid = res.data.data.value[3].id;
          this.prospectuser.project_id = res.data.data.value[3].project_id;
          this.prospectuser.value_id = res.data.data.value[3].id;
          // 项目主要内容
          this.maincontent = res.data.data.value[4].value;
          this.maincontentfiles = res.data.data.value[4].files;
          this.maincontentid = res.data.data.value[4].id;
          this.maincontentuser.project_id = res.data.data.value[4].project_id;
          this.maincontentuser.value_id = res.data.data.value[4].id;
          // 项目关键技术
          this.technology = res.data.data.value[5].value;
          this.technologyfiles = res.data.data.value[5].files;
          this.technologyid = res.data.data.value[5].id;
          this.technologyuser.project_id = res.data.data.value[5].project_id;
          this.technologyuser.value_id = res.data.data.value[5].id;
          // 技术创新点
          this.Innovapoint = res.data.data.value[6].value;
          this.Innovapointfiles = res.data.data.value[6].files;
          this.Innovapointid = res.data.data.value[6].id;
          this.Innovapointuser.project_id = res.data.data.value[6].project_id;
          this.Innovapointuser.value_id = res.data.data.value[6].id;
          // 技术指标和经济指标
          this.Economic = res.data.data.value[7].value;
          this.Economicfiles = res.data.data.value[7].files;
          this.Economicid = res.data.data.value[7].id;
          this.Economicuser.project_id = res.data.data.value[7].project_id;
          this.Economicuser.value_id = res.data.data.value[7].id;
          // 方法和技术线路
          this.circuit = res.data.data.value[8].value;
          this.circuitfiles = res.data.data.value[8].files;
          this.circuitid = res.data.data.value[8].id;
          this.circuituser.project_id = res.data.data.value[8].project_id;
          this.circuituser.value_id = res.data.data.value[8].id;
          // 现有基础
          this.foundation = res.data.data.value[9].value;
          this.foundationfiles = res.data.data.value[9].files;
          this.foundationid = res.data.data.value[9].id;
          this.foundationuser.project_id = res.data.data.value[9].project_id;
          this.foundationuser.value_id = res.data.data.value[9].id;
          // 项目结题
          this.Junction = res.data.data.value[10].value;
          this.Junctionfiles = res.data.data.value[10].files;
          this.Junctionid = res.data.data.value[10].id;
          this.Junctionuser.project_id = res.data.data.value[10].project_id;
          this.Junctionuser.value_id = res.data.data.value[10].id;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    this.Apisrc = window.g.ApiUrl + "/ent_tech_research_development/uploader";
    this.centerNums = window.sessionStorage.getItem("centerNums");
    this.authority_text = window.sessionStorage.getItem("authority_text");
    Projectdetail({ id: window.sessionStorage.getItem("centerNums") }).then(
      (res) => {
        if (res.data.code == 200) {
          this.form.title = res.data.data.title;
          this.finish_status = res.data.data.finish_status;
          this.form.project_number = res.data.data.project_number;
          this.form.keyword = res.data.data.keyword;
          this.form.industry_small_text = res.data.data.industry_small_text;
          this.form.industry_text = res.data.data.industry_text;
          this.form.progress = res.data.data.progress;
          this.forms.date = res.data.data.start_date;
          this.forms.name = res.data.data.research_dev_title;
          this.forms.numbers = res.data.data.cooperation;
          this.forms.nature = res.data.data.manager_name;
          this.forms.desc = res.data.data.remark;
          this.approval = res.data.data.approval_text;
          this.approval_time = res.data.data.approval_time;
          this.finish_time = res.data.data.finish_time;
          this.finishte = res.data.data.finish_text;
          this.rduser = res.data.data.rduser;
          // 国内外现状、水平和发展趋势
          this.situation = res.data.data.value[0].value;
          this.situationfiles = res.data.data.value[0].files;
          this.situationid = res.data.data.value[0].id;
          this.user.project_id = res.data.data.value[0].project_id;
          this.user.value_id = res.data.data.value[0].id;
          // 本项目对公司的作用与意义
          this.meaning = res.data.data.value[1].value;
          this.meaningfiles = res.data.data.value[1].files;
          this.meaningid = res.data.data.value[1].id;
          this.meaninguser.project_id = res.data.data.value[1].project_id;
          this.meaninguser.value_id = res.data.data.value[1].id;
          // 项目预期达到的技术水平
          this.level = res.data.data.value[2].value;
          this.levelfiles = res.data.data.value[2].files;
          this.levelid = res.data.data.value[2].id;
          this.leveluser.project_id = res.data.data.value[2].project_id;
          this.leveluser.value_id = res.data.data.value[2].id;
          // 项目预期市场前景
          this.prospect = res.data.data.value[3].value;
          this.prospectfiles = res.data.data.value[3].files;
          this.prospectid = res.data.data.value[3].id;
          this.prospectuser.project_id = res.data.data.value[3].project_id;
          this.prospectuser.value_id = res.data.data.value[3].id;
          // 项目主要内容
          this.maincontent = res.data.data.value[4].value;
          this.maincontentfiles = res.data.data.value[4].files;
          this.maincontentid = res.data.data.value[4].id;
          this.maincontentuser.project_id = res.data.data.value[4].project_id;
          this.maincontentuser.value_id = res.data.data.value[4].id;
          // 项目关键技术
          this.technology = res.data.data.value[5].value;
          this.technologyfiles = res.data.data.value[5].files;
          this.technologyid = res.data.data.value[5].id;
          this.technologyuser.project_id = res.data.data.value[5].project_id;
          this.technologyuser.value_id = res.data.data.value[5].id;
          // 技术创新点
          this.Innovapoint = res.data.data.value[6].value;
          this.Innovapointfiles = res.data.data.value[6].files;
          this.Innovapointid = res.data.data.value[6].id;
          this.Innovapointuser.project_id = res.data.data.value[6].project_id;
          this.Innovapointuser.value_id = res.data.data.value[6].id;
          // 技术指标和经济指标
          this.Economic = res.data.data.value[7].value;
          this.Economicfiles = res.data.data.value[7].files;
          this.Economicid = res.data.data.value[7].id;
          this.Economicuser.project_id = res.data.data.value[7].project_id;
          this.Economicuser.value_id = res.data.data.value[7].id;
          // 方法和技术线路
          this.circuit = res.data.data.value[8].value;
          this.circuitfiles = res.data.data.value[8].files;
          this.circuitid = res.data.data.value[8].id;
          this.circuituser.project_id = res.data.data.value[8].project_id;
          this.circuituser.value_id = res.data.data.value[8].id;
          // 现有基础
          this.foundation = res.data.data.value[9].value;
          this.foundationfiles = res.data.data.value[9].files;
          this.foundationid = res.data.data.value[9].id;
          this.foundationuser.project_id = res.data.data.value[9].project_id;
          this.foundationuser.value_id = res.data.data.value[9].id;
          // 项目结题
          this.Junction = res.data.data.value[10].value;
          this.Junctionfiles = res.data.data.value[10].files;
          this.Junctionid = res.data.data.value[10].id;
          this.Junctionuser.project_id = res.data.data.value[10].project_id;
          this.Junctionuser.value_id = res.data.data.value[10].id;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      }
    );
  },
  mounted() {
    // BUS.$on("centerNums", (data) => {
    //   this.centerNums = data;
    //   Projectdetail({ id: data }).then((res) => {
    //     if (res.data.code == 200) {
    //       this.form.title = res.data.data.title;
    //       this.finish_status = res.data.data.finish_status;
    //       this.form.project_number = res.data.data.project_number;
    //       this.form.keyword = res.data.data.keyword;
    //       this.form.industry_small_text = res.data.data.industry_small_text;
    //       this.form.industry_text = res.data.data.industry_text;

    //       this.form.progress = res.data.data.progress;
    //       this.forms.date = res.data.data.start_date;
    //       this.forms.name = res.data.data.research_dev_title;
    //       this.forms.numbers = res.data.data.cooperation;
    //       this.forms.nature = res.data.data.manager_name;
    //       this.forms.desc = res.data.data.remark;
    //       this.approval = res.data.data.approval_text;
    //       this.approval_time = res.data.data.approval_time;
    //       this.finish_time = res.data.data.finish_time;
    //       this.finishte = res.data.data.finish_text;
    //       this.rduser = res.data.data.rduser;
    //       // 国内外现状、水平和发展趋势
    //       this.situation = res.data.data.value[0].value;
    //       this.situationfiles = res.data.data.value[0].files;
    //       this.situationid = res.data.data.value[0].id;
    //       this.user.project_id = res.data.data.value[0].project_id;
    //       this.user.value_id = res.data.data.value[0].id;
    //       // 本项目对公司的作用与意义
    //       this.meaning = res.data.data.value[1].value;
    //       this.meaningfiles = res.data.data.value[1].files;
    //       this.meaningid = res.data.data.value[1].id;
    //       this.meaninguser.project_id = res.data.data.value[1].project_id;
    //       this.meaninguser.value_id = res.data.data.value[1].id;
    //       // 项目预期达到的技术水平
    //       this.level = res.data.data.value[2].value;
    //       this.levelfiles = res.data.data.value[2].files;
    //       this.levelid = res.data.data.value[2].id;
    //       this.leveluser.project_id = res.data.data.value[2].project_id;
    //       this.leveluser.value_id = res.data.data.value[2].id;
    //       // 项目预期市场前景
    //       this.prospect = res.data.data.value[3].value;
    //       this.prospectfiles = res.data.data.value[3].files;
    //       this.prospectid = res.data.data.value[3].id;
    //       this.prospectuser.project_id = res.data.data.value[3].project_id;
    //       this.prospectuser.value_id = res.data.data.value[3].id;
    //       // 项目主要内容
    //       this.maincontent = res.data.data.value[4].value;
    //       this.maincontentfiles = res.data.data.value[4].files;
    //       this.maincontentid = res.data.data.value[4].id;
    //       this.maincontentuser.project_id = res.data.data.value[4].project_id;
    //       this.maincontentuser.value_id = res.data.data.value[4].id;
    //       // 项目关键技术
    //       this.technology = res.data.data.value[5].value;
    //       this.technologyfiles = res.data.data.value[5].files;
    //       this.technologyid = res.data.data.value[5].id;
    //       this.technologyuser.project_id = res.data.data.value[5].project_id;
    //       this.technologyuser.value_id = res.data.data.value[5].id;
    //       // 技术创新点
    //       this.Innovapoint = res.data.data.value[6].value;
    //       this.Innovapointfiles = res.data.data.value[6].files;
    //       this.Innovapointid = res.data.data.value[6].id;
    //       this.Innovapointuser.project_id = res.data.data.value[6].project_id;
    //       this.Innovapointuser.value_id = res.data.data.value[6].id;
    //       // 技术指标和经济指标
    //       this.Economic = res.data.data.value[7].value;
    //       this.Economicfiles = res.data.data.value[7].files;
    //       this.Economicid = res.data.data.value[7].id;
    //       this.Economicuser.project_id = res.data.data.value[7].project_id;
    //       this.Economicuser.value_id = res.data.data.value[7].id;
    //       // 方法和技术线路
    //       this.circuit = res.data.data.value[8].value;
    //       this.circuitfiles = res.data.data.value[8].files;
    //       this.circuitid = res.data.data.value[8].id;
    //       this.circuituser.project_id = res.data.data.value[8].project_id;
    //       this.circuituser.value_id = res.data.data.value[8].id;
    //       // 现有基础
    //       this.foundation = res.data.data.value[9].value;
    //       this.foundationfiles = res.data.data.value[9].files;
    //       this.foundationid = res.data.data.value[9].id;
    //       this.foundationuser.project_id = res.data.data.value[9].project_id;
    //       this.foundationuser.value_id = res.data.data.value[9].id;
    //       // 项目结题
    //       this.Junction = res.data.data.value[10].value;
    //       this.Junctionfiles = res.data.data.value[10].files;
    //       this.Junctionid = res.data.data.value[10].id;
    //       this.Junctionuser.project_id = res.data.data.value[10].project_id;
    //       this.Junctionuser.value_id = res.data.data.value[10].id;
    //     } else {
    //       this.dialogVisiblenull = true;
    //       this.errormessage = res.data.msg;
    //     }
    //   });
    // });

    BUS.$on("prontreport", (data) => {
      if (data == "yess") {
        this.dialogVisibleinitreport = false;
        this.dialogVisibleclosreport = false;
      }
    });
  },
};
</script>
<style scoped>
.rediogree {
  display: inline-block;
  width: 6px;
  height: 6px;
  background: #e7e9ef;
  border-radius: 50%;
  position: relative;
  bottom: 2px;
  right: 2px;
}
.abstract {
  border-left: 4px solid #52c5cb;
  height: 20px;
  line-height: 20px;
}
table {
  border-collapse: collapse;
}
tr {
  width: 100%;
}
td {
  border: 1px solid #f0f0f0;
}
.tdtit {
  width: 15%;
  height: 40px;
  line-height: 40px;
  background: #f1f3f9;
  border: 1px solid rgba(233, 233, 233, 1);
  padding-left: 10px;
  font-size: 14px;
  color: #6a7589;
}
.tdcont {
  width: 35%;
  padding-left: 10px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #353a44;
}
.tdconts {
  width: 85%;
  padding-left: 10px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #353a44;
}
.approvebtn {
  display: inline-block;
  width: 80px;
  height: 26px;
  line-height: 26px;
  border-radius: 4px;
  background-color: rgba(58, 126, 230, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  margin: 5px 0 0 5px;
}
.approvebtns {
  display: inline-block;
  width: 80px;
  height: 26px;
  line-height: 26px;
  border-radius: 4px;
  background-color: rgba(58, 126, 230, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  margin: 5px 0 0 0;
}
.removebtn {
  display: inline-block;
  width: 12px;
  height: 12px;
  color: #fff;
  background: #969eac;
  border-radius: 50%;
  position: relative;
  top: 3px;
}
.el-icon-close {
  font-size: 12px !important;
  position: absolute;
}
.filebtnbg {
  background: #f6f7fb;
  margin-bottom: 10px;
  padding: 3px 10px;
}
.acceptancecomments {
  text-indent: 20px;
  text-align: left;
  width: 70%;
  line-height: 30px;
  padding-left: 10px;
  background-color: rgba(239, 242, 181, 1);
  border: 1px solid rgba(187, 187, 187, 1);
}
.itemconten >>> .el-form-item__content {
  text-align: left;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>